import { createContext, useContext, useEffect, useMemo, useState } from "react";
import apiClient from "../api/client";

const BrandingContext = createContext(null);

const defaultBranding = {
  club_name: "Syd's Golf At GGR",
  logo_url:
    "https://customer-assets.emergentagent.com/job_6597845f-a2ea-476e-82a0-c568dbe57e74/artifacts/ujs781ee_Goldfield%20Game%20Ranch%20Voucher.png",
  colors: {
    primary: "#514a3f",
    gold: "#dfa625",
    black: "#101010",
    white: "#f9f9f7",
  },
};

const applyBrandingVars = (branding) => {
  const root = document.documentElement;
  root.style.setProperty("--ggr-primary", branding.colors.primary);
  root.style.setProperty("--ggr-gold", branding.colors.gold);
  root.style.setProperty("--ggr-black", branding.colors.black);
  root.style.setProperty("--ggr-white", branding.colors.white);
};

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(defaultBranding);

  const loadBranding = async () => {
    try {
      const response = await apiClient.get("/branding");
      if (response?.data?.colors) {
        setBranding(response.data);
        applyBrandingVars(response.data);
      }
    } catch {
      applyBrandingVars(defaultBranding);
    }
  };

  useEffect(() => {
    applyBrandingVars(defaultBranding);
    loadBranding();
  }, []);

  const value = useMemo(
    () => ({
      branding,
      reloadBranding: loadBranding,
      setBranding,
    }),
    [branding],
  );

  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error("useBranding must be used within BrandingProvider");
  }
  return context;
};
